export default "__VITE_ASSET__DOq0GxDM__"